import React from 'react';
import { compose } from 'ramda';
import styleFile from './LoyaltyUserPoints.js';
import { connect } from 'react-redux';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import RichText from '@synergycms_core/components/generic/RichText';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';

  const LoyaltyUserPoints = class STUserPoints extends React.Component {
    static displayName = 'LoyaltyUserPoints';
    render() {
      const { config, theme } = this.props;
      const { classes } = theme.styles;
      const { loyaltyUser } = config;
  
      if(!loyaltyUser) {
        return null;
      }
      
      const totalPoints = loyaltyUser.getIn(['points', 'total'], false)
      return (
      <div className={classes.starUserContainerDiv}>
        <span className={[theme.computedInnerStyle, classes.starUserContainer].join(' ')}>
          <RichText
            text={loyaltyUser.get('name')}
            innerStyle={['roboto14Black', 'capitalize', classes.stDefault]}
          />
          {totalPoints !== false && 
          <>
            <RichText text={' | ' + totalPoints}
                      innerStyle={[classes.stDefault]}
            />
            {' '}
            <RichText
              translate={true}
              ucFirst={true}
              innerStyle={[classes.stDefault]}
              text={'_%puntos Star Traveler%_'}
            />
          </>} 
        </span>
      </div>
      );
    }
  };
  
  const mapStateToProps = (store, ownProps) => {
    return {
      loyaltyUser : store.getIn(['customer', 'loyalty', 'user']),
    }
  };
    
    export default compose(
    connect(
      mapStateToProps,
    ),
    PropertyManager(['loyaltyUser']),
    withThemeJSS({ styleFile, link: true }),
  )(LoyaltyUserPoints);
  
  